<template>
<component
    :is="tagName"
    :type="tagName === 'button' ? 'button' : null"
    :class="[
        'mdc-button',
        outlined && 'mdc-button--outlined',
        unelevated && 'mdc-button--unelevated',
        raised && 'mdc-button--raised'
    ]"
    :to="to">
    <div class="mdc-button__ripple"></div>
    <svg-icon
        v-if="leadingIcon"
        class="mdc-button__icon"
        aria-hidden="true"
        :name="leadingIcon" />
    <span
        v-if="label"
        class="mdc-button__label">{{ label }}</span>
    <svg-icon
        v-if="trailingIcon"
        class="mdc-button__icon"
        aria-hidden="true"
        :name="trailingIcon" />
    <slot></slot>
</component>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
export default {
    components: { SvgIcon },
    props: {
        outlined: Boolean,
        unelevated: Boolean,
        raised: Boolean,
        label: { type: String, default: "" },
        leadingIcon: { type: String, default: null },
        trailingIcon: { type: String, default: null },
        tagName: { type: String, default: "button" },
        to: { type: String, default: null }
    }
};
</script>
